import type { Override } from "@bbj-types/utils";
import CloseIcon from "@mui/icons-material/Close";
import {
  Button,
  DialogActions,
  DialogContent,
  type DialogProps,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import type React from "react";
import { Dialog } from "../../surfaces/Dialog";

export interface IConfirmationModalProps extends Override<DialogProps, { title: React.ReactNode }> {
  id?: string;
  children?: React.ReactNode;
  loading?: boolean;
  disableValidate?: boolean;
  textConfirmButton: string;
  onConfirmClick: () => void;
  textCancelButton: string;
  onCancelClick: () => void;
}

export const ConfirmationModal = ({
  id,
  title,
  children,
  textConfirmButton,
  onConfirmClick,
  textCancelButton,
  onCancelClick,
  loading,
  disableValidate,
  open,
  ...props
}: IConfirmationModalProps) => {
  return (
    <Dialog id={id} open={open} onClose={onCancelClick} {...props}>
      <DialogTitle component={Stack} direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="h4" noWrap>
          {title}
        </Typography>
        <IconButton size="small" onClick={onCancelClick}>
          <CloseIcon fontSize="medium" color="primary" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {children &&
          (typeof children === "string" ? (
            <Typography variant="body1" gutterBottom>
              {children}
            </Typography>
          ) : (
            children
          ))}
      </DialogContent>
      <DialogActions>
        <Button
          id={`${id}-cancel-btn`}
          onClick={onCancelClick}
          color="primary"
          variant="outlined"
          name="cancel"
          aria-labelledby={textCancelButton}
          disabled={loading}
        >
          {textCancelButton}
        </Button>
        <Button
          id={`${id}-confirm-btn`}
          onClick={onConfirmClick}
          color="primary"
          variant="contained"
          name="confirm"
          aria-labelledby={textConfirmButton}
          disabled={disableValidate}
          loading={loading}
        >
          {textConfirmButton}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
